module.exports = __webpack_public_path__ + "img/details.af3a32d2.svg";